export const EXPANDED_QUERY_PARAM_KEY = 'expanded';
